export default "__VITE_ASSET__BJSlQAfL__"